import { Feed } from './Feed';
import { PostComposer } from './PostComposer';

export const CommunityView = ({
  communitySubView,
  setCommunitySubView,
  // PostComposer props
  getUserStats,
  MIN_SENDS_TO_POST,
  shareText,
  setShareText,
  MAX_POST_LENGTH,
  isPosting,
  postError,
  shareCategory,
  setShareCategory,
  shareVibe,
  setShareVibe,
  wouldSendAgain,
  setWouldSendAgain,
  addToFeed,
  // Feed props
  feedFilter,
  setFeedFilter,
  showSendAgainOnly,
  setShowSendAgainOnly,
  selectedCategory,
  setSelectedCategory,
  isLoadingFeed,
  getFilteredFeed,
  userId,
  userVotes,
  activeCommentPost,
  setActiveCommentPost,
  comments,
  commentText,
  setCommentText,
  commentCooldown,
  isPostingComment,
  addComment,
  upvotePost,
  flagPost,
  deletePost,
  flagComment,
  deleteComment,
  shareToSocial,
  formatTimestamp,
  setViewingProfile,
  setShowProfile,
  getUserCategoryBreakdown,
  getUserRecentSends,
  AUTO_HIDE_FLAG_THRESHOLD,
  MAX_COMMENT_LENGTH,
  MIN_COMMENT_LENGTH,
}) => {
  return (
    <div className="space-y-4 sm:space-y-5">
      <div className="bg-gradient-to-r from-red-600 to-orange-600 border-3 sm:border-4 border-red-400 p-4 sm:p-5 skew-x-[-2deg]">
        <h2 className="text-3xl sm:text-4xl font-black text-white uppercase tracking-tight skew-x-[2deg]">COMMUNITY</h2>
      </div>

      {/* Sub-navigation tabs */}
      <div className="flex gap-2 px-3 sm:px-4">
        <button
          onClick={() => setCommunitySubView('feed')}
          className={`flex-1 py-3 font-black uppercase text-sm border-3 transition-all ${communitySubView === 'feed'
            ? 'bg-red-500 text-black border-red-400'
            : 'bg-black text-red-500 border-red-500 hover:bg-red-900'
            }`}
        >
          📰 FEED
        </button>
        <button
          onClick={() => setCommunitySubView('post')}
          className={`flex-1 py-3 font-black uppercase text-sm border-3 transition-all ${communitySubView === 'post'
            ? 'bg-lime-500 text-black border-lime-400'
            : 'bg-black text-lime-500 border-lime-500 hover:bg-lime-900'
            }`}
        >
          ✍️ POST
        </button>
      </div>

      {communitySubView === 'post' && (
        <PostComposer
          getUserStats={getUserStats}
          MIN_SENDS_TO_POST={MIN_SENDS_TO_POST}
          shareText={shareText}
          setShareText={setShareText}
          MAX_POST_LENGTH={MAX_POST_LENGTH}
          isPosting={isPosting}
          postError={postError}
          shareCategory={shareCategory}
          setShareCategory={setShareCategory}
          shareVibe={shareVibe}
          setShareVibe={setShareVibe}
          wouldSendAgain={wouldSendAgain}
          setWouldSendAgain={setWouldSendAgain}
          addToFeed={addToFeed}
        />
      )}

      {communitySubView === 'feed' && (
        <Feed
          feedFilter={feedFilter}
          setFeedFilter={setFeedFilter}
          showSendAgainOnly={showSendAgainOnly}
          setShowSendAgainOnly={setShowSendAgainOnly}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          isLoadingFeed={isLoadingFeed}
          getFilteredFeed={getFilteredFeed}
          userId={userId}
          userVotes={userVotes}
          activeCommentPost={activeCommentPost}
          setActiveCommentPost={setActiveCommentPost}
          comments={comments}
          commentText={commentText}
          setCommentText={setCommentText}
          commentCooldown={commentCooldown}
          isPostingComment={isPostingComment}
          addComment={addComment}
          upvotePost={upvotePost}
          flagPost={flagPost}
          deletePost={deletePost}
          flagComment={flagComment}
          deleteComment={deleteComment}
          shareToSocial={shareToSocial}
          formatTimestamp={formatTimestamp}
          setViewingProfile={setViewingProfile}
          setShowProfile={setShowProfile}
          getUserCategoryBreakdown={getUserCategoryBreakdown}
          getUserRecentSends={getUserRecentSends}
          AUTO_HIDE_FLAG_THRESHOLD={AUTO_HIDE_FLAG_THRESHOLD}
          MAX_COMMENT_LENGTH={MAX_COMMENT_LENGTH}
          MIN_COMMENT_LENGTH={MIN_COMMENT_LENGTH}
        />
      )}
    </div>
  );
};
